import FloorGeneralInformation from './ExternalDoorInRowGeneralInformation';

export default FloorGeneralInformation;